export default __webpack_public_path__ + "static/media/dashboard_graph.ab27413a.svg";